import { ExclamationCircleIcon, ExclamationTriangleIcon, SparklesIcon } from "@heroicons/react/24/solid";
import { Spinner } from "../../utils/Spinner";
import { RecordingTranscriptPair } from "../../utils/SessionUtils";
import { capitalize } from "lodash";
import { getNodeStatusColor } from "../../utils/MetagraphUtils";

interface RecordingTranscriptPairTitleProps {
    recordingTranscriptPair: RecordingTranscriptPair;
    colorOverride?: string;
}

export const RecordingTranscriptPairTitle: React.FC<RecordingTranscriptPairTitleProps> = ({ 
    recordingTranscriptPair,
    colorOverride,
}) => {
    const getFallbackRecordingName = (transcriptTitle: string | undefined, transcriptionStatus: string, recordingTimestampIso: string | undefined) => {
        try {
            const date_string = recordingTimestampIso ? (new Date(recordingTimestampIso)).toLocaleString() : undefined
            if (transcriptionStatus === "Completed" && transcriptTitle) 
                return date_string ? `${transcriptTitle} (from ${date_string})` : transcriptTitle;

            const recording_with_timestamp = date_string ? `recording from ${date_string}` : "Recording and Transcript"

            if (transcriptionStatus === "Not Started") {
                return capitalize(`${recording_with_timestamp} (Transcription not started)`) 
            } else if (transcriptionStatus === "Processing") {
                return `Processing ${recording_with_timestamp}`
            } else if (transcriptionStatus === "FailedNoData") {
                return capitalize(`Recording missing, skipped transcription (${recording_with_timestamp})`) 
            } else if (transcriptionStatus.includes("Failed")) {
                return capitalize(`Failed transcription (${recording_with_timestamp})`) 
            }

            return capitalize(recording_with_timestamp);    
        } catch {
            return "Recording and Transcript";
        }
    }

    const transcriptStatus: string = recordingTranscriptPair.transcript_status;
    const title = getFallbackRecordingName(
        recordingTranscriptPair.transcript_title, 
        transcriptStatus, 
        recordingTranscriptPair.recording_timestamp
    );

    const color = colorOverride ?? getNodeStatusColor(transcriptStatus);

    return (
        <div className="flex items-center gap-x-2">
            {transcriptStatus === "Processing" && <Spinner size="h-4 w-4" timer={true} className={`fill-${color}-900`} />}
            {transcriptStatus === "Failed" && <ExclamationCircleIcon className={`h-5 w-5 text-${color}-500`} />}
            {transcriptStatus === "FailedNoData" && <ExclamationTriangleIcon className={`h-5 w-5 text-${color}-500`} />}
            {transcriptStatus === "Completed" && <SparklesIcon className={`h-5 w-5 text-${color}-500`} />}
            <span>{title}</span>
        </div>
    );
};
